import { isString } from "@/utils"

export default {
  removeDiacritics(text) {
    return text.replace(/./g, a => lookupTable[a] || a)
  },

  contains(query) {
    const searchQuery = this.search(query)
    return text => {
      return searchQuery(text).length > 0
    }
  },

  search(query) {
    if (!isString(query)) {
      return () => []
    }
    const convertedQueries = query
      .split(/\s+/)
      .filter(query => query.length > 0)
      .map(query => this.removeDiacritics(query.toLowerCase()))
    return text => {
      if (!isString(query)) {
        return []
      }
      const convertedText = this.removeDiacritics(text.toLocaleLowerCase())
      return convertedQueries
        .map(convertedQuery => this.indexes(convertedText, convertedQuery))
        .reduce((acc, indexes) => acc.concat(indexes), [])
        .reduce(
          (acc, idx) => acc.fill(1, idx.start, idx.end),
          Array(text.length).fill(0)
        )
        .reduce((acc, bit, i) => {
          if (bit === 1) {
            const lastMatch = acc[acc.length]
            if (lastMatch == null || lastMatch.end !== i) {
              acc.push({ start: i, end: i + 1 })
            } else {
              lastMatch.end = i + 1
            }
          }
          return acc
        }, [])
    }
  },

  indexes(text, query) {
    const result = []
    let idx = text.indexOf(query)
    while (idx >= 0) {
      result.push({
        start: idx,
        end: idx + query.length
      })
      idx = text.indexOf(query, idx + 1)
    }
    return result
  }
}

const lookupTable = {
  // slovak (https://sk.wikipedia.org/wiki/Slovensk%C3%A1_abeceda)
  á: "a",
  ä: "a",
  č: "c",
  ď: "d",
  é: "e",
  í: "i",
  ĺ: "l",
  ľ: "l",
  ň: "n",
  ó: "o",
  ô: "o",
  ŕ: "r",
  š: "s",
  ť: "t",
  ú: "u",
  ý: "y",
  ž: "z",
  Á: "A",
  Ä: "A",
  Č: "C",
  Ď: "D",
  É: "E",
  Í: "I",
  Ĺ: "L",
  Ľ: "L",
  Ň: "N",
  Ó: "O",
  Ô: "O",
  Ŕ: "R",
  Š: "S",
  Ť: "T",
  Ú: "U",
  Ý: "Y",
  Ž: "Z",
  // czech addon (https://sk.wikipedia.org/wiki/%C4%8Cesk%C3%A1_abeceda)
  ě: "e",
  ř: "r",
  ů: "u",
  Ě: "E",
  Ř: "R",
  Ů: "U"
}
